import { token } from '@zillow/constellation';
import styled from 'styled-components';

export const MobileDropdownMenuMegaMenuContainer = styled.div`
    border-top: 1px solid ${token('colors.borderLight')};
    background: #fbfbfb;
    padding: 0px 30px;
`;
